export default __webpack_public_path__ + "static/media/chevron_right-blue.50588033.svg";